export type QaError = {
  priority: string;
  applicationId: string;
  applicationName: string;
  excludeErrorCode?: string[] | null;
  siteCode: string;
  scriptName: string;
  status: string;
  statusDetails: string;
  bugs: string;
  scriptHealth: string;
  errorThreshold: string;
  currentError: string;
  priorityOverridden: boolean;
  thresholdOverridden: boolean;
};

export type QaErrorDetails = {
  appId: string;
  siteCode: string;
  scriptName: string;
  errorCode: string | null;
  currentErrorAvg: string;
  errorAvg2Days: string;
  errorAvg7Days: string;
  errorAvg15Days: string;
  currentInputsAvg: string;
  inputsAvg2Days: string;
  inputsAvg7Days: string;
  inputsAvg15Days: string;
  currentInputs: string;
  errorMsg: string;
};

export type QaErrorsTimestamp = string;

export type QaApplication = {
  appId: string;
  appName: string;
};

export enum Status {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum Threshold {
  AboveThreshold = 'Above',
  EqualThreshold = 'Equal',
  BelowThreshold = 'Below',
}

export namespace QaErrorsList {
  export type Request = {
    sortingOrder: 'asc' | 'desc';
    sortingColumn: keyof QaError;
    size: number;
    offset: number;
  };
  export type Response = {
    errorsList: QaError[];
    totalRecords: string;
    sortingorder: string;
    sortingcolumn: string;
    size: string;
    offset: string;
  };
}

export namespace QaErrorDetailsList {
  export type Request = {
    sortingOrder: 'asc' | 'desc';
    sortingColumn: keyof QaErrorDetails;
    size: number;
    offset: number;
    appId: string;
    siteCode: string;
    scriptName: string;
    errorCode: string | null;
  };
  export type Response = {
    errorsList: QaErrorDetails[];
    totalRecords: string;
    sortingorder: string;
    sortingcolumn: string;
    size: string;
    offset: string;
  };
}

export namespace QaSiteCodeList {
  export type Response = {
    sitecodelist: string[];
  };
}

export namespace QaScriptNameList {
  export type Response = {
    scriptNames: string[];
  };
}

export namespace ErrorMessagesList {
  export type Item = {
    message: string;
    count: number;
  };

  export type Request = {
    sortingOrder: 'asc' | 'desc';
    sortingColumn: keyof Item;
    size: number;
    offset: number;
  };

  export type Response = {
    errorCode: number;
    messagesList: Item[];
    totalRecords: string;
  };
}

export type SideCodesFilterResponse = {
  siteCodes: string[];
};
export type ScriptNamesFilterResponse = {
  scriptNames: string[];
};
export type ErrorCodesFilterResponse = {
  errorCodes: number[];
};
